import { useState, useEffect } from 'react';
import { fetchBoats, deleteBoats } from '../../services/AdminBoatService';
import { fetchCategories } from '../../services/AdminCategoryService';

const useBoatActions = () => {
  const [boats, setBoats] = useState([]);
  const [filteredBoats, setFilteredBoats] = useState([]);
  const [selectedBoats, setSelectedBoats] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadBoats();
    loadCategories();
  }, []);

  useEffect(() => {
    filterBoats();
  }, [selectedCategory, searchTerm, boats]);

  const clearSelectedBoats = () => {
    const updatedBoats = filteredBoats.map((boat) => ({
      ...boat,
      isSelected: false
    }));
    setFilteredBoats(updatedBoats);
    setSelectedBoats([]);
  };

  const loadBoats = async () => {
    setIsLoading(true);
    try {
      const data = await fetchBoats();
      setBoats(data);
      setFilteredBoats(data);
    } catch (error) {
      // Handle or log errors here if needed
    } finally {
      setIsLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      const data = await fetchCategories();
      setCategories(data);
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  const handleBulkDelete = async (selectedBoats) => {
    try {
      const boatIds = selectedBoats.map((boat) => boat.id);
      await deleteBoats(boatIds);
    } catch (error) {
      // Handle errors if needed
    }
  };

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const filterBoats = () => {
    let filtered = boats;

    if (searchTerm) {
      filtered = filtered.filter(
        (boat) =>
          boat.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          boat.id.toString().includes(searchTerm)
      );
    }

    if (selectedCategory) {
      const selectedCategoryId = parseInt(selectedCategory, 10);
      filtered = filtered.filter((boat) => boat.category.id === selectedCategoryId);
    }

    setFilteredBoats(filtered);
  };

  const handleSelectAll = (isSelected) => {
    const updatedBoats = filteredBoats.map((boat) => ({
      ...boat,
      isSelected: isSelected
    }));

    setFilteredBoats(updatedBoats);
    setSelectedBoats(isSelected ? filteredBoats : []);
  };

  const handleBoatSelect = (boatId, isSelected) => {
    const updatedBoats = filteredBoats.map((boat) =>
      boat.id === boatId ? { ...boat, isSelected: isSelected } : boat
    );

    setFilteredBoats(updatedBoats);

    if (isSelected) {
      const selectedBoat = filteredBoats.find((boat) => boat.id === boatId);
      setSelectedBoats([...selectedBoats, selectedBoat]);
    } else {
      setSelectedBoats(
        selectedBoats.filter((boat) => boat.id !== boatId)
      );
    }
  };

  return {
    boats,
    filteredBoats,
    selectedBoats,
    categories,
    selectedCategory,
    setSelectedBoats,
    loadBoats,
    handleBulkDelete,
    handleFilter,
    handleCategoryChange,
    handleSelectAll,
    handleBoatSelect,
    clearSelectedBoats,
    isLoading
  };
};

export default useBoatActions;